import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Button, Popover } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import SearchInput from '../ReusableComponents/SearchInput';
import Loader from '../ReusableComponents/Loader';
import { DeletePopup } from '../ReusableComponents/DeletePopup';
import TmMasterTable from '../ReusableComponents/TmMasterTable';
import { toastError, toastSuccess, toastWarn } from '../Toast/ToastComponent';
import { TrainingsApi } from '../../Api/TrainingsApi';
import { getTrainings } from '../../store/reducers/actionPermission';
import { useAuth } from '../../Context/AuthContext';
import { Tooltip } from 'antd';

const STATUS_COLOR = {
  ACTIVE: 'alert-info',
  ONGOING: 'alert-warning',
  COMPLETED: 'alert-success',
  UPCOMING: 'alert-secondary',
};

const PillList = ({ items = [], maxVisible = 2 }) => {
  const visible = items.slice(0, maxVisible);
  const extra = items.length - maxVisible;

  return (
    <div
      style={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: 6,
        alignItems: 'center',
      }}
    >
      {visible.map((name, index) => (
        <span
          key={index}
          style={{
            backgroundColor: '#e6f7ff',
            color: '#0050b3',
            fontSize: '12px',
            fontWeight: 500,
            padding: '2px 10px',
            borderRadius: '20px',
            lineHeight: '1.5',
            display: 'inline-flex',
            alignItems: 'center',
            whiteSpace: 'nowrap',
            border: '1px solid #91d5ff',
          }}
        >
          {name}
        </span>
      ))}

      {extra > 0 && (
        <span
          style={{
            backgroundColor: '#f5f5f5',
            color: '#595959',
            fontSize: '12px',
            fontWeight: 500,
            padding: '2px 10px',
            borderRadius: '20px',
            lineHeight: '1.5',
            display: 'inline-flex',
            alignItems: 'center',
            whiteSpace: 'nowrap',
            border: '1px solid #d9d9d9',
            cursor: 'pointer',
          }}
          title={items.slice(maxVisible).join(', ')}
        >
          +{extra} more
        </span>
      )}
    </div>
  );
};
const HoverChipList = ({ items = [], maxVisible = 2 }) => {
  const visible = items.slice(0, maxVisible);
  const hidden = items.slice(maxVisible);

  const content = (
    <div>
      {items.map((name, i) => (
        <div key={i} style={{ padding: '2px 0' }}>
          {name}
        </div>
      ))}
    </div>
  );

  return (
    <div
      style={{
        display: 'flex',
        gap: 5,
        flexWrap: 'wrap',
        alignItems: 'center',
      }}
    >
      {visible.map((name, index) => (
        <span
          key={index}
          style={{
            backgroundColor: '#e3f2fd',
            color: '#1976d2',
            padding: '4px 10px',
            borderRadius: '6px',
            fontSize: '12px',
            fontWeight: 500,
          }}
        >
          {name}
        </span>
      ))}

      {hidden.length > 0 && (
        <Popover content={content} trigger="hover">
          <span
            style={{
              backgroundColor: '#f0f0f0',
              color: '#333',
              padding: '4px 8px',
              borderRadius: '6px',
              fontSize: '12px',
              fontWeight: 600,
              cursor: 'pointer',
            }}
          >
            +{hidden.length} more
          </span>
        </Popover>
      )}
    </div>
  );
};
export const TrainingsTableColmns = [
  {
    field: 'serialNo',
    headerName: 'S.NO',
    render: (value) => (
      <span
        style={{
          fontWeight: 600,
          color: '#1F4E78',
        }}
      >
        {value}
      </span>
    ),
  },

  {
    field: 'trainingName',
    headerName: 'TRAINING NAME',
    render: (value) => (
      <span
        style={{
          color: '#262626',
          fontWeight: 500,
        }}
      >
        {value}
      </span>
    ),
  },

  {
    field: 'trainers',
    headerName: 'TRAINERS',
    render: (trainers = []) => {
      const visible = trainers.slice(0, 2);
      const extra = trainers.length - 2;

      return (
        <Tooltip
          title={
            <div>
              {trainers.map((name, i) => (
                <div key={i}>{name}</div>
              ))}
            </div>
          }
        >
          <div style={{ display: 'flex', gap: 5, flexWrap: 'wrap' }}>
            {visible.map((name, index) => (
              <span
                key={index}
                style={{
                  backgroundColor: '#CFE2FF',
                  color: '#0c4b8a',
                  padding: '4px 10px',
                  borderRadius: '6px',
                  fontSize: '12px',
                }}
              >
                {name}
              </span>
            ))}

            {extra > 0 && (
              <span
                style={{
                  backgroundColor: '#CFE2FF',
                  color: '#0c4b8a',
                  padding: '4px 8px',
                  borderRadius: '6px',
                  fontSize: '12px',
                  fontWeight: 600,
                  cursor: 'pointer',
                }}
              >
                +{extra}
              </span>
            )}
          </div>
        </Tooltip>
      );
    },
  },

  {
    field: 'trainees',
    headerName: 'TRAINEES',
    render: (trainees = []) => {
      const visible = trainees.slice(0, 2);
      const extra = trainees.length - 2;

      return (
        <Tooltip
          title={
            <div>
              {trainees.map((name, i) => (
                <div key={i}>{name}</div>
              ))}
            </div>
          }
        >
          <div style={{ display: 'flex', gap: 5, flexWrap: 'wrap' }}>
            {visible.map((name, index) => (
              <span
                key={index}
                style={{
                  backgroundColor: '#CFE2FF',
                  color: '#0c4b8a',
                  padding: '4px 10px',
                  borderRadius: '6px',
                  fontSize: '12px',
                }}
              >
                {name}
              </span>
            ))}

            {extra > 0 && (
              <span
                style={{
                  backgroundColor: '#CFE2FF',
                  color: '#0c4b8a',
                  padding: '4px 8px',
                  borderRadius: '6px',
                  fontSize: '12px',
                  fontWeight: 'bold',
                  cursor: 'pointer',
                }}
              >
                +{extra}
              </span>
            )}
          </div>
        </Tooltip>
      );
    },
  },

  {
    field: 'duration',
    headerName: 'DURATION',
  },

  {
    field: 'training_status',
    headerName: 'STATUS',
    render: (value) => {
      const statusKey = value?.toUpperCase().replace(/\s/g, '') || '';

      const colorConfig = {
        COMPLETED: {
          text: '#145c32',
          bg: '#d1e7dd',
          border: '#a3cfbb',
        },
        ONGOING: {
          text: '#856404',
          bg: '#fff3cd',
          border: '#f8de90',
        },
        INPROGRESS: {
          text: '#856404',
          bg: '#fff3cd',
          border: '#ffe69c',
        },
        ACTIVE: {
          text: '#084298',
          bg: '#cfe2ff',
          border: '#b6d4fe',
        },
        UPCOMING: {
          text: '#41464b',
          bg: '#e2e3e5',
          border: '#d3d3d4',
        },
      };

      const config = colorConfig[statusKey] || {
        text: '#41464b',
        bg: '#e2e3e5',
        border: '#d3d3d4',
      };

      return (
        <span
          style={{
            color: config.text,
            backgroundColor: config.bg,
            border: `1.5px solid ${config.border}`,
            padding: '4px 12px',
            borderRadius: '50px',
            fontSize: '13px',
            fontWeight: 600,
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            lineHeight: '1',
            textTransform: 'capitalize',
            whiteSpace: 'nowrap',
          }}
        >
          {value}
        </span>
      );
    },
  },
];
const TrainingList = () => {
  const navigate = useNavigate();
  const permission = useSelector(getTrainings);
  const { authState } = useAuth();
  const debounceRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [search, setSearch] = useState('');
  const [counts, setCounts] = useState({
    ACTIVE: 0,
    ONGOING: 0,
    COMPLETED: 0,
    UPCOMING: 0,
  });
  const [buttonPermission, setButtonPermissions] = useState({
    add: true,
    edit: true,
    delete: true,
    view: true,
  });
  useEffect(() => {
    if (permission) {
      const obj = {};
      permission.actions?.forEach((el) => {
        obj[el.statename.toLowerCase()] = el.checked;
      });
      if (
        (authState?.role_id === 4 || authState?.role_id === 3) &&
        ![1, 2].includes(Number(authState?.id))
      ) {
        obj.add = false;
        obj.edit = false;
        obj.delete = false;
        obj.view = true;
      }
      setButtonPermissions(obj);
    }

    if (authState?.id) {
      getTrainingList();
    }
  }, [permission, authState?.id, authState?.role_id]);

  const getTrainingList = async (searchValue = '', statusValue = '') => {
    try {
      setLoading(true);

      const payload = {
        user_id: authState?.id,
        training_status: statusValue || '',
        search: searchValue || '',
      };
      const res = await TrainingsApi.getTrainingList(payload);
      if (res?.data?.success) {
        const result = res?.data?.result;
        setCounts(result?.counts || {});
        const mappedData = (result?.data || []).map((item, index) => ({
          id: item.id,

          key: item.id,

          serialNo: index + 1,

          trainingName: item.training_name,

          trainers: item?.trainers?.map((trainer) => trainer.username) || [],

          trainees: item?.trainees?.map((trainee) => trainee.username) || [],

          duration: `${item?.duration?.days || 0} Days`,

          isTraineeRow: [1, 2].includes(Number(authState?.id))
            ? false
            : item?.trainees?.some((t) => t.id === authState?.id),
          isTrainerRow: [1, 2].includes(Number(authState?.id))
            ? false
            : item?.trainers?.some((t) => t.id === authState?.id),

          training_status: item.training_status,
          status: item.status,
        }));
        const isAnyRowTrainer = mappedData.some((row) => row.isTrainerRow);
        if (isAnyRowTrainer && ![1, 2].includes(Number(authState?.id))) {
          setButtonPermissions((prev) => ({
            ...prev,
            add: false,
            edit: false,
            delete: false,
          }));
        }
        setData(mappedData);
        setFilteredData(mappedData);
      } else {
        toastWarn(res?.data?.message || 'No records found');
      }
    } catch (err) {
      toastError(
        err?.response?.data?.message || err?.message || 'Something went wrong',
      );
    } finally {
      setLoading(false);
    }
  };

  const handleSearchChange = (value) => {
    setSearch(value);
    if (debounceRef.current) {
      clearTimeout(debounceRef.current);
    }
    debounceRef.current = setTimeout(() => {
      getTrainingList(value);
    }, 500);
  };

  const handleDelete = async (id) => {
    DeletePopup(async (ok) => {
      if (!ok) return;

      try {
        const res = await TrainingsApi.deleteTraining({
          id,
        });

        if (res?.data?.success) {
          toastSuccess(res?.data?.message || 'Training deleted successfully');

          getTrainingList(search);
        } else {
          toastWarn(res?.data?.message);
        }
      } catch (err) {
        toastError(err?.response?.data?.message || err?.message);
      }
    });
  };

  const handleRowClick = async (record) => {
    try {
      setLoading(true);
      const payload = {
        training_id: record.id,
        user_id: authState?.id,
      };
      const res = await TrainingsApi.getTrainingOverview(payload);
      if (res?.data?.success) {
        navigate('/trainings_view', {
          state: {
            overviewData: res.data.result,
          },
        });
      } else if (
        res?.data?.success === false &&
        res?.data?.message === 'trainee'
      ) {
        navigate('/trainings_view', {
          state: {
            overviewData: {
              training_details: {
                id: record.id,
                training_name: record.trainingName,
                status: record.status,
              },
            },
            isTrainee: true,
          },
        });
      } else {
        toastWarn(res?.data?.message || 'Overview not found');
      }
    } catch (err) {
      toastError(err?.response?.data?.message || err?.message);
    } finally {
      setLoading(false);
    }
  };

  const stats = [
    {
      label: 'Active Trainings',
      value: counts?.ACTIVE || 0,
    },
    {
      label: 'Ongoing Trainings',
      value: counts?.ONGOING || 0,
    },
    {
      label: 'Completed Trainings',
      value: counts?.COMPLETED || 0,
    },
    {
      label: 'Upcoming Sessions',
      value: counts?.UPCOMING || 0,
    },
  ];

  return (
    <div>
      <div
        style={{
          display: 'flex',
          alignItems: 'stretch',
          gap: 12,
          marginBottom: 20,
        }}
      >
        {[1, 2].includes(Number(authState?.id)) &&
          stats.map((item) => (
            <div
              key={item.label}
              style={{
                background: '#fff',
                border: '1px solid #e8e8e8',
                borderRadius: 6,
                padding: '10px 18px',
                minWidth: 150,
              }}
            >
              <div
                style={{
                  fontSize: 12,
                  color: '#8c8c8c',
                  marginBottom: 4,
                }}
              >
                {item.label}
              </div>

              <div
                style={{
                  fontSize: 22,
                  fontWeight: 700,
                  color: '#1a3c5e',
                }}
              >
                {item.value}
              </div>
            </div>
          ))}
        <div
          style={{
            marginLeft: 'auto',
            display: 'flex',
            alignItems: 'center',
            gap: 8,
          }}
        >
          <SearchInput
            placeholder="Search..."
            value={search}
            onSearchChange={handleSearchChange}
          />

          {buttonPermission.add && (
            <Button
              type="primary"
              icon={<PlusOutlined />}
              style={{
                width: 40,
                height: 33,
              }}
              onClick={() => navigate('/create_trainings')}
            />
          )}
        </div>
      </div>
      {loading ? (
        <Loader />
      ) : (
        <TmMasterTable
          buttonPermission={buttonPermission}
          rows={filteredData}
          columns={TrainingsTableColmns}
          custom={['action', 'trainers', 'trainees', 'training_status']}
          toggleModal={(type, record) => {
            if (type === 'Edit') navigate(`/create_trainings/${record.id}`);
            if (type === 'View') handleRowClick(record);
          }}
          handleDelete={handleDelete}
          renderCustomColumn={(field, record) => {
            if (field === 'trainers')
              return <HoverChipList items={record.trainers} />;

            if (field === 'trainees')
              return <HoverChipList items={record.trainees} />;

            if (field === 'training_status') {
              return (
                <span
                  className={`alert ${STATUS_COLOR[record.training_status] || 'alert-secondary'} mb-0 py-0 px-2 rounded-pill`}
                  style={{
                    fontWeight: 600,
                    fontSize: '12px',
                    display: 'inline-block',
                  }}
                >
                  {record.training_status}
                </span>
              );
            }
          }}
        />
      )}
    </div>
  );
};
export default TrainingList;
